import React, { Component, Fragment } from 'react'
import Table from '@common/Table'
import columns from './columns'
import { inject, observer } from 'mobx-react'
@inject('pushListStore')
@observer
export default class extends Component {
  render() {
    return (
      <Fragment>
        <div
          style={{
            color: '#333',
            fontSize: 16,
            padding: '27px 0'
          }}
        >
          推送列表
        </div>
        <Table
          store={this.props.pushListStore}
          columns={columns(this.props.pushListStore)}
        />
      </Fragment>
    )
  }
}
